import React,{useState,useEffect,useRef} from 'react'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Download } from '@mui/icons-material';

import DocumentForm from '../components/DocumentForm'
import useSystemMasterList from '../../../hooks/useSystemMasterList';
import documentServices from '../services/documentServices';
import withFmsLayout from '../layout/withFmsLayout';
import DateSelect2 from '../../../components/AppInput/DateSelect2';
import useUserList from '../../../hooks/useUserList';
import { Link } from 'react-router-dom';

const CellLink = (params) =>{
  return (
      <Link to={`/fms/document/${params.data.id}`}>{params.data.title}</Link>
  )
}

function DocumentListPage() {
    const [masters,getMasterLabel] = useSystemMasterList(['department',"document-category","document-status","document-type"]);
    const [filter,setFilter] = useState(null);
    const [documentList,setDocumentList] = useState(null);

    const {userList,getUserName} = useUserList();

    const getDocumentList = () =>{
        if(filter!==null){
            documentServices.getList(filter).then(res=>{
                setDocumentList(res.data)
            }).catch(error=>{
            console.log(error);
            })
        }
    }

    /* Grid Work */
      const gridRef = useRef();
      const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
        resizable: true,
        width:180,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
      });
    
      const [columnDefs,setColumnDef] = useState();
      const prepairColumnDef = () => {
          let _columnDefs = [
            {field:"id",headerName: "ID"},
            {field:"documentDate",headerName:"Document Date"},
            {field:"title",headerName:"Title", valueGetter: params => params.data.title,cellRenderer: CellLink},
            {headerName:"Created By",valueGetter: (params) => getUserName(params.data.userId)},


            {field:"departmentId",headerName: "Department",valueGetter: (params) => getMasterLabel("department",params.data.departmentId)},
            {field:"categoryId",headerName: "Category",valueGetter: (params) => getMasterLabel("document-category",params.data.categoryId)},
            {field:"documentType",headerName: "DocumentType",valueGetter: (params) => getMasterLabel("document-type",params.data.documentType)},
            {field:"documentStatus",headerName: "DocumentStatus",valueGetter: (params) => getMasterLabel("document-status",params.data.documentStatus)},

            {field:"updated_at",headerName:"Last Updated"},
          ];
          setColumnDef(_columnDefs);
      }
    
    useEffect(()=>{
        getDocumentList()
    },[filter])

    const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
    }

    useEffect(()=>{
        if(masters && userList) {
          prepairColumnDef()
        }
    },[masters])

    return (
      <div className='row'>
            <div className='col-md-6'>
                <span className='float-end'>
                        <DateSelect2 filter={filter} setFilter={setFilter} />
                        {documentList && <button type="button" onClick={onBtnExport} className="btn btn-primary ms-3 float-end"><Download/>  Export</button> }
                      </span>
            </div>
            <div className='col-md-6'>
                <span className='float-end'><DocumentForm callBack={getDocumentList} masters={masters} /></span>
            </div>
            <div className='col-md-12 mt-3'>
                <div className="ag-theme-alpine" style={{height:600}}>
                    {masters && 
                        <AgGridReact
                            ref={gridRef}
                            rowData={documentList}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            animateRows={true}
                            onGridReady={getDocumentList}
                        />
                    }
                </div>
            </div>
      </div>
        
    )
}

export default withFmsLayout(DocumentListPage);